import styled from 'styled-components';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { useWindowWidth } from '@elfsight/lib-utils';
import { useIsMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { getStyleConfig } from '../../constants/style-config';
import { TABLET_BREAKPOINT } from '../constants';

export const Message = ({ isFormSubmitted }: { isFormSubmitted: boolean }) => {
  const { message, messageMobile, messageColor, barSize, barSizeMobile } =
    useSettings();

  const windowWidth = useWindowWidth();
  const isCentered = windowWidth < TABLET_BREAKPOINT;
  const isMobile = useIsMobile();

  if (isFormSubmitted) return null;

  const resultMessage = isMobile && messageMobile ? messageMobile : message;

  const messageFont = getStyleConfig(isMobile).message[
    isMobile ? barSizeMobile : barSize
  ] as TextStyleValue;

  return (
    <TextHTML
      _isCentered={isCentered}
      _font={messageFont}
      _color={messageColor}
      dangerouslySetInnerHTML={{
        __html: resultMessage
      }}
    />
  );
};

const TextHTML = styled.div<{
  _color?: string;
  _font?: TextStyleValue;
  _isCentered: boolean;
}>`
  line-height: 1.2;
  color: ${({ _color }) => _color};
  font-size: ${({ _font }) => _font?.fontSize}px;
  text-align: ${({ _isCentered }) => (_isCentered ? 'center' : 'left')};
`;
